/** Espelha a comparação normalizada do backend (src/lib/gravacao.js). */
export function normalizarGravacao(gravacao) {
  return String(gravacao ?? '')
    .trim()
    .toUpperCase();
}

/** PARCIAL, NULL ou vazio podem ser excluídos. DEFINITIVO não. */
export function podeExcluirDocumento(gravacao) {
  const valor = normalizarGravacao(gravacao);
  return valor === '' || valor === 'PARCIAL';
}

/** Espelha statusReceitaPermiteExclusao do backend. Pedido da farmácia fica de fora. */
export function podeExcluirReceita(gravacao, status) {
  if (!podeExcluirDocumento(gravacao)) return false;
  const valor = String(status ?? '')
    .trim()
    .toUpperCase();
  return valor === '' || valor === 'PRESCRITA';
}

export function mensagemErroExclusao(err, fallback) {
  const apiMessage = err?.response?.data?.message || err?.response?.data?.error;
  if (apiMessage) return apiMessage;

  const status = err?.response?.status;
  if (status === 409) return 'Documento definitivo não pode ser excluído.';
  if (status === 404) return 'Documento não encontrado.';
  return fallback;
}
